import { Flex, spacing } from 'deepstash-ui';
import React from 'react';
import { Idea, Source } from 'types/models';
import IdeaCardDropdown from './IdeaCardDropdown';
import IdeaReadsLabel from './IdeaReadsLabel';
import IdeaStashButton from './stash-button/IdeaStashButton';

interface IdeaCardActionBarProps {
  source: Source | null;
  idea: Idea;
  /**
   * Signal up the tree that this idea got stashed
   */
  onIdeaStashed?: () => void;
  /**
   * Signal up the tree that this idea got unstashed
   */
  onIdeaUntashed?: () => void;
  // [Like functionality]
  // onHeartLike?: () => void;
  // onHeartUnlike?: () => void;
}

// const IdeaLikeButton = dynamic(() => import('./IdeaLikeButton'));

const IdeaCardActionBar: React.FC<IdeaCardActionBarProps> = ({
  source,
  idea,
  onIdeaStashed,
  onIdeaUntashed,
  // [Like functionality]
  // onHeartLike,
  // onHeartUnlike,
}) => {
  return (
    <Flex
      w="100%"
      paddingTop={spacing.S.rem}
      justifyContent="space-between"
      alignItems="center"
      onClick={e => e.stopPropagation()}
    >
      <Flex align="center">
        <IdeaStashButton
          idea={idea}
          source={source}
          onIdeaStashed={onIdeaStashed}
          onIdeaUnstashed={onIdeaUntashed}
        />
      </Flex>
      <Flex>
        <IdeaReadsLabel idea={idea} />
        <IdeaCardDropdown source={source} idea={idea} />
      </Flex>
    </Flex>
  );
};

export default React.memo(IdeaCardActionBar);
